<template>
  <div class="maintenance-tips">
    <div class="text">{{ $t('main-1.key123', { cm: '维护中' }) }}</div>
    <img :src="images.maintenance" class="maintenance-icon" />
  </div>
</template>

<script>
import maintenance from 'assets/images/refactor-main/maintenance.png';
export default {
  name: 'maintenance-tips',
  data() {
    return {
      images: {
        maintenance,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/css/variable.scss';

.maintenance-tips {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .text {
    font-family: PingFangSC-Regular;
    font-size: px(24);
    color: #505564;
    text-align: center;
    line-height: px(32);
    margin-right: px(12);
  }
  .maintenance-icon {
    width: px(24);
    height: px(24);
  }
}
</style>
